<template>
  <div class="divided-prices">
    <div
      v-if="!prices.length && isEditable"
      @click.stop="addFirstPrice"
      class="price-placeholder"
    >
      <slot name="placeholder">{{ placeholderText }}</slot>
    </div>
    <template
      v-else
      v-for="(priceObj, i) in prices"
    >
      <editable-text
        v-for="(val, key) in priceObj"
        :key="i"
        :ref="`price-${i}`"
        tag="span"
        :class="[`item-price item-price-${i}`, {'ui-hidden':hideGlobalUI}]"
        :content="prices[i].price"
        :editable="isEditable"
        @update="prices[i].price = $event"
        @keydown.native="onKeydownGeneric($event, i)"
        @keydown.enter.native="onKeyupEnter($event,i)"
        @keydown.delete.native="onKeydownDelete($event,i)"
        @onBlur="onBlur"
      />
      <span class="divider" v-if="prices.length > 1 && i < prices.length-1"> {{ divider }} </span>
    </template>
  </div>  
</template>

<script>
import EditableTextField from '../EditableTextField'

import { mapState } from 'vuex';

export default {

  name: 'DividedPriceColumns',
  props : {
    'prices' : {
      type:[Array, Boolean]
    },
    'divider' : {
      type : String,
      default : '/'
    },
    'placeholderText' : {
      type : String,
      default : '$'
    },
    isEditable : {
      type : Boolean,
      default : false
    }
  },
  components : {
    'editable-text' : EditableTextField,    
  },
  computed : {
    ...mapState(['hideGlobalUI'])
  },    
  data () {
    return {

    }
  },
  methods : {
    onKeydownGeneric(e, priceIndex) {
      if( e.key == this.divider ) {
        e.preventDefault();
        this.onKeyupEnter(e, priceIndex)
      }
    }, // onKeydownGeneric
    onKeyupEnter(e, priceIndex) {
      let priceObj = this.prices[ priceIndex ];
      if( !priceObj.price.toString().length ) {
        e.preventDefault();
        return false;
      }
      e.preventDefault();
      this.addPrice(priceIndex)      
      let self = this;
      this.$nextTick().then(()=>{
        self.focusPrice(priceIndex+1)
      });
    }, // onKeyupEnter

    addPrice(priceIndex) {
      this.prices.push({'price' :''});
    }, // addPrice

    focusPrice(priceIndex) {
      this.$refs[`price-${priceIndex}`][0].$el.focus();
    }, // focusPrice

    addFirstPrice() {
      this.addPrice();
      var self = this
      this.$nextTick().then(()=>{
        self.focusPrice(0)
      });
    }, // addFirstPrice

    onKeydownDelete(e, priceIndex) {
      let price = this.prices[ priceIndex ].price;
      if( !price.length && this.prices.length >= 1 ) {
        e.preventDefault();
        this.removePrice(priceIndex)
        let self = this;
        // Only try to remove and focus is there
        // are more prices left to mess with
        if( this.prices.length ) {
          this.$nextTick().then(()=>{
            var p = self.$refs[`price-${priceIndex-1}`][0].$el;
            var s = window.getSelection();
            s.collapse(p.firstChild, p.innerText.length);
          });
        }
      }
    }, // onKeydownDelete

    removePrice(priceIndex) {
      this.prices.splice(priceIndex,1);
    }, // addPrice
    
    onBlur(event, text,i) {
      // "this.prices.length == 1" will be true at two points:
      // 1. User deletes the last char of the 2nd to last price
      //        (e.g. "2.5/2" <-- onDelete)
      //      - bc by the time onBlur fires, that 2nd price is spliced out
      // 2. User leaves an empty space or two in the only price and clicks off
      //        (e.g. "  " onBlur)
      //      - this is the expected behavior
      if( this.prices.length == 1 && !text.trim().length ) {
        // TODO: don't allow this to be so brittle
        // right now, looking for item-price-0 narrows down the
        // above two possibilites. 'item-price-1' will be the event.target
        // of example #1 above
        if( event.target.classList.contains('item-price-0') ) {
          this.prices.splice(0,1)
        }
      }
    }, // onBlur
  }, // methods

}
</script>

<style lang="scss">

.divided-prices {
  display:flex;
  justify-content:flex-end;
  text-align:right;
  
  flex: auto;
  .item-price {
    flex:0 1 auto;
  }

  [contenteditable] {
    transition:border-color .3s ease, background-color .3s ease;
    border-bottom:2px solid transparent;
  }
}


.item-price {
  // flex:0 0 8px;
  padding-right:0;
  &.empty-text:not(.ui-hidden) {
    display:block;
    width:1px;
    padding-right:5px;
    padding-left:2px;
    border-bottom:2px solid #40C2FF;
    &:focus, &:active {
      border-bottom:2px solid #40C2FF;
      background-color:rgba(#40C2FF, .3);
    }
    &:not(.selected):hover {
      background-color:rgba(#40C2FF, .3);
    }

  }
}

.price-placeholder {
  color:darken(white, 25%);
  font-style:italic;
  font-size:.8rem;
  line-height:1em;
}

.divider {
  flex:0 0 10px;
  text-align:center;
  border-bottom:2px solid transparent;
}


</style>


// WEBPACK FOOTER //
// src/components/UI/DividedPriceColumns.vue